const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-kbd ---
let __fez_component_0;
{
const MAC = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)
const LABELS = { mod: MAC ? '⌘' : 'Ctrl', shift: MAC ? '⇧' : 'Shift', alt: MAC ? '⌥' : 'Alt', enter: 'Enter', esc: 'Esc', up: '↑', down: '↓' }
__fez_component_0 = class {
  NAME = 'span'

  PROPS = {
    keys: { type: String, default: '' },
  }

  beforeRender() {
    this.state.caps = this.props.keys.split(/\s+/).filter(Boolean).map((key) => LABELS[key] || key.toUpperCase())
  }

  CSS = `:fez {
display:inline-flex;gap:2px;vertical-align:middle;kbd{display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 5px;border:1px solid var(--color-border-strong);border-bottom-width:2px;border-radius:var(--radius-sm);background:var(--color-bg-subtle);color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);line-height:1}
}`

  HTML = `{#each state.caps as cap}
<kbd>{cap}</kbd>
{/each}`
};
}

Fez('ui-kbd', __fez_component_0);

export default __fez_component_0;
